export default "__VITE_ASSET__3228ea1d__"